<div class="rooms-container">
  <div class="preferencial-provider" *ngIf="prioritizedTag">
    <mb-icon icon="award"></mb-icon>
    <span>Proveedor preferencial</span>
  </div>
  <room
    *ngIf="cluster.rooms.length === 1"
    [isHomestay]="isHomestay"
    [room]="cluster.rooms[0]"
    [idHotel]="hotelAvailabilityInfo.id"
    [roomsDetail]="hotelAvailabilityInfo.rooms_detail"
    [mealPlan]="cluster.rates[0]?.meal_plan"
    [index]="0"
    [numberRoom]="1"
    [latestRooms]="cluster.rates[0]?.latest_rooms"
  ></room>

  <ng-container *ngIf="cluster.rooms.length > 1">
    <am-room-information
      *ngFor="let room of cluster.rooms; let i = index"
      [room]="room"
      [hideImage]="false"
      [useCompactStyle]="true">
    </am-room-information>
  </ng-container>
</div>
<div *ngIf="cluster?.rates?.length" class="rates-container">
  <div *ngFor="let rate of cluster.rates | isEconomic: rate"
       class="rate rate--fixed-height">
    <meal-plan class="meal-plan" [beds]="bedInfo" [rate]="rate"></meal-plan>
    <payment-advise
      [rate]="rate"
      [argentina]="isArgentina"
      [isExperts]="isExperts"
    ></payment-advise>
    <total-price
      [rateInput]="rate"
      [clusterInput]="cluster"
      [experts]="isExperts"
      [showAmountTotal]="showAmountTotal"
      [priceByValue]="priceByValue"
      [hotelStaticInfo]="hotelStaticInfo"
      [hotelAvailabilityInfo]="hotelAvailabilityInfo"
      [isArgentinian]="isArgentina"
    ></total-price>
  </div>
</div>
